import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

import { getPaddingValue } from "../utils/getSafeAreaPaddings";

export const muiDrawerOverrides: Components<Theme> = {
  MuiDrawer: {
    styleOverrides: {
      paperAnchorBottom: ({ theme }) => ({
        maxWidth: "var(--page-max-width)",
        // bottom sheet should be limited by the safe area so it doesn't intersect with the notch
        // added additional margin so it looks a bit nicer
        maxHeight: `calc(100% - ${getPaddingValue("top", theme.spacing(5))} - ${theme.spacing(3)})`,
        margin: "0 auto",
      }),
    },
  },
};
